__turbopack_context__.v({
  "layer": "tL_dqW_layer",
  "morph": "tL_dqW_morph",
  "stage": "tL_dqW_stage",
});
